/**
 * @module Theme
 */

import { Component, Input, OnInit } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-axes-grid-lines-color',
  templateUrl: './theme-option-axes-grid-lines-color.component.html',
  styleUrls: ['./theme-option-axes-grid-lines-color.component.css']
})
export class ThemeOptionAxesGridLinesColorComponent implements OnInit {

  @Input() themeOptions: ThemeOptionsClass;
  @Input() axesIndex: number;
  @Input() axesXY: 'x' | 'y';

  showDetails: boolean;
  color = ItemColor('themes');
  opacity: number;
  gridlinesColor: string;
  optionType: ThemeOptionType = 'axes_gridLines_color';

  constructor() {}

  receiveShowDetails(showDetails: boolean) {
    this.showDetails = showDetails;
  }

  ngOnInit() {
    this.gridlinesColor = this.themeOptions.axes(this.axesXY, this.axesIndex).gridLines.color.toString().slice(0, 7);
    this.opacity = Math.round(parseInt(this.themeOptions.axes(this.axesXY, this.axesIndex).gridLines.color.toString().slice(7, 9), 16) * 100 / 255);
  }
  
  receiveValue(value: string) {
    this.gridlinesColor = value;
    this.themeOptions.setAxes(this.optionType, value + Math.round(this.opacity * 255 / 100).toString(16), this.axesXY, this.axesIndex);
  }

  receiveOpacity(value: number) {
    this.opacity = value;
    if(this.opacity > 0) {
      this.themeOptions.setAxes(this.optionType, this.gridlinesColor + Math.round(value * 255 / 100).toString(16), this.axesXY, this.axesIndex);
    }
    else {
      this.themeOptions.setAxes(this.optionType, this.gridlinesColor + '00', this.axesXY, this.axesIndex);
    }
  }

}
